import { ApplicationRoutes } from "../routes";

export interface BroadcastNotificationRoute {
	routeName: string;
	eqivalentWebRoute: string;
}

export const BROADCAST_NOTIFICATION_ROUTES: BroadcastNotificationRoute[] = [
	{ routeName: "/home_page", eqivalentWebRoute: `/${ApplicationRoutes.DASHBOARD}` },
	{ routeName: "/buy_electricity", eqivalentWebRoute: `/${ApplicationRoutes.BUY_ELECTRICITY}` },
	{ routeName: "/energy_management_routing_page", eqivalentWebRoute: `/${ApplicationRoutes.CUSTOMER_ENERGY_MANAGEMENT}` },
	{ routeName: "/consumption_analytics_page", eqivalentWebRoute: `/${ApplicationRoutes.CUSTOMER_ENERGY_MANAGEMENT}/${ApplicationRoutes.CUSTOMER_CONSUMPTION_ANALYTICS}` },
	{ routeName: "/service_request_routing_page", eqivalentWebRoute: `/${ApplicationRoutes.SERVICE_REQUEST_MODULE}` },
	{ routeName: "/wallet_page", eqivalentWebRoute: `/${ApplicationRoutes.CUSTOMER_WALLET}` },
	{ routeName: "/history_page", eqivalentWebRoute: `/${ApplicationRoutes.CUSTOMER_TRANSACTION_HISTORY}` },
	{ routeName: "/family_account_management", eqivalentWebRoute: `/settings/${ApplicationRoutes.TEAM_MANAGEMENT}` },
	{ routeName: "/energy_profile_view_page", eqivalentWebRoute: `/settings/${ApplicationRoutes.CUSTOMER_ENERGY_PROFILE}` },
	{ routeName: "/reset_password_page", eqivalentWebRoute: `/settings/${ApplicationRoutes.SECURITY}` },
	{ routeName: "/customer_pin_routing_page", eqivalentWebRoute: `/settings/${ApplicationRoutes.SECURITY}` },
	{ routeName: "/appearance_page", eqivalentWebRoute: `/settings/${ApplicationRoutes.CUSTOMER_APPEARANCE}` },
];
